import * as _ from 'lodash';
// import FileSizeFilter from '../util/fileSize.filter';
import * as FileTypes from '../core/util/fileTypes.const';
import { IUploadFileService } from '../core/util/selectFilesPane.component';

import { IUploadFileApi } from '../upload/upload.module';

/**
 * Transform a File object to a simple file object with the fields we need
 *
 * TODO: Move the get extension to core/util
 */
const toUploadFile = (file) => ({
  name: _.get(file, 'name', ''),
  ext: _.get(file, 'name', '').split('.').pop(),
  data: file
});

export default class UploadOfferPricingFileService
  implements IUploadFileService {
  private state;
  private resourceData;

  private worker;

  private uploadApi: IUploadFileApi;

  fileModel;

  unsubscribeFromStore;

  private isValidFileType = FileTypes.checkFileExt('xls', 'xlsx', 'csv');

  constructor(
    public UploadModel,
    private Upload,
    private FileParser,
    private $q
  ) {
    'ngInject';
  }

  $onInit() {
    this.state = this.UploadModel.store.getState();

    this.unsubscribeFromStore = this.UploadModel.store.subscribe(() => {
      // Update angularjs if the state is changed via redux debugger
      // this.$scope.$applyAsync(() => {
      this.state = this.UploadModel.store.getState();
      // });
    });
  }

  setWorker(worker) {
    this.worker = worker;
  }

  setUploadApi(uploadApi) {
    this.uploadApi = uploadApi;
  }

  setResourceData(resourceData) {
    this.resourceData = resourceData;
  }

  getFile() {
    return this.state.file;
  }

  selectFile(file) {
    file = toUploadFile(file.pop());

    let action = this.UploadModel.selectFile(file);
    this.UploadModel.store.dispatch(action);
    this.verifyValidFile(this.state.file)
      .then(_.bind(this.getFirstRows, this))
      .then(_.bind(this.handleFirstRows, this))
      .then(_.bind(this.markFileReady, this))
      .then(_.bind(this.uploadFile, this))
      .catch(_.bind(this.handleParseError, this));

    // We could also do this, but async/await might be slower
    // let parseFile = asyncPipe(
    //   _.bind(this.verifyValidFile, this),
    //   _.bind(this.getFirstRows, this),
    //   _.bind(this.handleFirstRows, this),
    //   _.bind(this.markFileReady, this)
    // );

    // parseFile(this.state.file)
    //   .then(_.bind(this.uploadFile, this))
    //   .catch(_.bind(this.handleParseError, this));
  }

  verifyValidFile(file) {
    let dValidFile = this.$q.defer();

    if (this.isValidFileType(file)) {
      dValidFile.resolve(file);
    } else {
      dValidFile.reject('Invalid file format');
    }

    return dValidFile.promise;
  }

  getFirstRows(file) {
    return this.FileParser.getFirstRowsFromFile(file, this.worker);
  }

  handleFirstRows({ file, worksheets }) {
    let d = this.$q.defer();

    let action = this.UploadModel.updateWorksheets(worksheets);
    this.UploadModel.store.dispatch(action);

    if (!worksheets) {
      d.reject('File Error');
    } else if (worksheets.length == 0) {
      d.reject('Content not found');
    } else {
      d.resolve(file);
    }

    return d.promise;
  }

  markFileReady(file) {
    let action = this.UploadModel.setFileReady(true);
    this.UploadModel.store.dispatch(action);

    this.state = this.UploadModel.store.getState();

    return this.$q.when(file);
  }

  uploadFile(file) {
    let action = this.UploadModel.uploadFile(file);
    this.UploadModel.store.dispatch(action);
    let state = this.UploadModel.store.getState();

    return this.uploadApi
      .uploadFiles(file.data, this.resourceData)
      .then((response) => {
        let fileUploadId = response.data ? response.data[0].id : response[0].id;
        let action = this.UploadModel.whenFileUploaded(fileUploadId);
        this.UploadModel.store.dispatch(action);
      })
      .catch((response) => {
        throw new Error('Error: ' + response.data.message);
      });
  }

  handleParseError(err) {
    let action = this.UploadModel.setFileError(err);
    this.UploadModel.store.dispatch(action);

    this.state = this.UploadModel.store.getState();
  }
}
